@if (reportForm) {
  <form
    [formGroup]="reportForm"
    (ngSubmit)="generateReport(reportForm)"
    style="overflow-y: hidden; overflow-x: hidden;"
    >
    <h1 mat-dialog-title class="report-form-header">
      {{reportName}}:
    </h1>
    <mat-dialog-content style="overflow-y: hidden; overflow-x: hidden;">
      <mat-form-field>
        <mat-label>Select Start Date</mat-label>
        <input
          matInput
          formControlName="startDate"
          [matDatepicker]="startDate"
          [max]="maxDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="startDate"
          ></mat-datepicker-toggle>
          <mat-datepicker #startDate [disabled]="false"></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Select End Date</mat-label>
          <input
            matInput
            formControlName="endDate"
            [matDatepicker]="endDate"
            [max]="maxDate"
            />
            <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate [disabled]="false"></mat-datepicker>
            @if (reportForm.errors?.endDateLessThanStartDate) {
              <small
                class="text-danger"
                >
                <ng-container id="endDateInvalid">
                  End Date must be greater than or equal to Start Date
                </ng-container>
              </small>
            }
            @if (reportForm.errors?.dateRangeGreaterThanAYear) {
              <small class="text-danger">
                <ng-container id="dateRangeInvalid">
                  Date range cannot be greater than one year
                </ng-container>
              </small>
            }
          </mat-form-field>
          @if (displayTestDataOptions) {
            <div class="test-options-container">
              <label>Include Test Users</label>
              <mat-radio-group class="row options" formControlName="includeTestData">
                <mat-radio-button class="col-4 col-sm-2" [value]=true>Yes</mat-radio-button>
                <mat-radio-button class="col-4 col-sm-2" [value]=false>No</mat-radio-button>
              </mat-radio-group>
            </div>
          }
        </mat-dialog-content>
        <mat-dialog-actions class="mb-0" align="end">
          <button mat-raised-button type="button" color="primary" mat-dialog-close>
            Cancel
          </button>
          <button
            mat-raised-button
            type="submit"
            color="primary"
            [disabled]="!reportForm.valid"
            >
            <mat-icon class="icon-white">queue</mat-icon>&nbsp;&nbsp;&nbsp;{{ buttonLabel }}
          </button>
        </mat-dialog-actions>
      </form>
    }
